import * as React from 'react';
export var ModalContext = React.createContext({});
//# sourceMappingURL=ModalContext.js.map